import { render, staticRenderFns } from "./DesktopCartView.vue?vue&type=template&id=018d9f06&scoped=true&"
import script from "./DesktopCartView.vue?vue&type=script&lang=ts&"
export * from "./DesktopCartView.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopCartView.vue?vue&type=style&index=0&id=018d9f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018d9f06",
  null
  
)

component.options.__file = "DesktopCartView.vue"
export default component.exports